"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _polished = require("polished");

var _styled = _interopRequireWildcard(require("../styled"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 20px 0;\n  margin: 6px 0;\n  user-select: none;\n  outline: none;\n\n  ", ";\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return (0, _styled.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    cursor: ", ";\n  "])), disabled ? 'no-drop' : 'pointer');
});

var ThumbWrapper = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  right: 0;\n  width: 50%;\n  transform-origin: left center;\n  z-index: 3;\n  transform: scale3d(1, 1, 1);\n"])));

var Thumb = _styled["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  width: 12px;\n  height: 12px;\n  border-radius: 100%;\n  transform: translate(50%, -50%);\n  transition: box-shadow 250ms cubic-bezier(0.25, 0.8, 0.25, 1) 0ms;\n\n  ", ";\n"])), function (props) {
  return (0, _styled.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-shadow: 0 0 0 0 ", ";\n\n    @media (hover: hover) {\n      &:hover,\n      &:focus {\n        box-shadow: 0 0 0 6px ", ";\n      }\n    }\n\n    /* Active */\n    ", " & {\n      ", "\n      ", "\n    }\n  "])), props.theme.foreground, (0, _polished.transparentize)(0.75, props.theme.foreground), (0, _polished.transparentize)(0.75, props.theme.foreground), Wrapper, props.active && (0, _styled.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        box-shadow: 0 0 0 12px ", ";\n      "])), (0, _polished.transparentize)(0.75, props.theme.foreground)), props.disabled && (0, _styled.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        box-shadow: 0 0 0 4px ", ";\n      "])), props.theme.background));
});

var Track = _styled["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 2px;\n  top: calc(50% - 1px);\n  width: 100%;\n  z-index: 1;\n  transform: scale3d(1, 1, 1);\n"])));

var TrackLower = (0, _styled["default"])(Track)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  left: 0;\n  transform-origin: center left;\n  background-color: ", ";\n"])), function (props) {
  return props.theme.foreground;
});
var TrackUpper = (0, _styled["default"])(Track)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  right: 0;\n  transform-origin: center right;\n  background-color: ", ";\n"])), function (props) {
  return (0, _polished.transparentize)(0.8, props.theme.foreground);
}); // Convert percentage to value within min and max range

var percentToValue = function percentToValue(percent, min, max) {
  return (max - min) * percent / 100 + min;
}; // Clamp value between min and max


var clamp = function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
};

// Calculate how far the cursor is within the Wrapper element, and clamp if it's outside
function calculatePercent(node, event) {
  var rect = node.getBoundingClientRect();
  var left = rect.left + global.pageXOffset;
  var x = event.pageX;
  var value = x - left;
  var onePercent = rect.width / 100;
  return clamp(value / onePercent, 0, 100);
} // Snap value to closest step


var snapToStep = function snapToStep(number, step) {
  return Math.round(number / step) * step;
};

var disableScroll = function disableScroll(e) {
  return e.preventDefault();
};
/**
 * This component is useful when you want to ask the user to give you a value within a range.
 *
 * problems with the built in browser implementations and inconsistencies between them.
 * Read this [blog post](https://css-tricks.com/sliding-nightmare-understanding-range-input/ "A Sliding Nightmare: Understanding the Range Input | CSS-Tricks"),
 * if you're interested in the gory details!
 *
 * It mostly tries to behave like a regular react input, however, this does not accept all the props an input would accept. It accepts only the props listed here,
 * alongside `className` and `style`.
 */


var Slider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Slider, _React$PureComponent);

  var _super = _createSuper(Slider);

  function Slider() {
    var _this;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_warnUncontrolledToControlled", false);

    _defineProperty(_assertThisInitialized(_this), "_warnControlledToUncontrolled", false);

    _defineProperty(_assertThisInitialized(_this), "container", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false,
      value: _this.props.initialValue
    });

    _defineProperty(_assertThisInitialized(_this), "handlePointerDown", function () {
      if (_this.props.disabled) return;

      _this.setState({
        active: true
      });

      _this.addDocumentListeners();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePointerUp", function (event) {
      _this.setState({
        active: false
      });

      _this.handlePointerMove(event);

      _this.removeDocumentListeners();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePointerMove", function (event) {
      if (!_this.container.current) return;
      if (!event.isPrimary) return; // We only care about primary pointers

      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;
      var percent = calculatePercent(_this.container.current, event);
      var value = percentToValue(percent, min, max);

      _this.handleChange(value, event);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePointerLeave", function (event) {
      _this.handlePointerMove(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePointerEnter", function (event) {
      if (event.isPrimary && event.pressure === 0) {
        _this.setState({
          active: false
        });

        _this.removeDocumentListeners();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (rawValue, _event) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          step = _this$props2.step;
      var value = step ? snapToStep(rawValue, step) : rawValue; // If the value prop is undefined or null, assume we are an uncontrolled input

      if (_this.props.value === undefined || _this.props.value === null) {
        _this.setState({
          value: value
        });
      }

      if (typeof onChange === 'function') {
        onChange({
          value: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "selectValue", function () {
      // If there is a value prop, assume it's a controlled input, and use the value of the prop!
      var value = typeof _this.props.value === 'number' ? _this.props.value : _this.state.value;
      var _this$props3 = _this.props,
          min = _this$props3.min,
          max = _this$props3.max; // Don't forget to adjust the value to the min/max bounds so we don't break rendering

      return clamp(value, min, max);
    });

    _defineProperty(_assertThisInitialized(_this), "addDocumentListeners", function () {
      var body = document.body;

      if (body) {
        body.addEventListener('pointerleave', _this.handlePointerLeave);
        body.addEventListener('pointerenter', _this.handlePointerEnter);
        body.addEventListener('pointerup', _this.handlePointerUp);
        body.addEventListener('pointermove', _this.handlePointerMove);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeDocumentListeners", function () {
      var body = document.body;

      if (body) {
        body.removeEventListener('pointerleave', _this.handlePointerLeave);
        body.removeEventListener('pointerenter', _this.handlePointerEnter);
        body.removeEventListener('pointerup', _this.handlePointerUp);
        body.removeEventListener('pointermove', _this.handlePointerMove);
      }
    });

    return _this;
  }

  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          onChange = _this$props4.onChange,
          value = _this$props4.value,
          readOnly = _this$props4.readOnly;

      if (typeof value === 'number' && typeof onChange !== 'function' && !readOnly) {
        console.warn('You provided no `onChange` prop, but provided a `value` prop. If you are sure this component should be read-only, add the `readOnly` prop');
      }

      if (this.container.current) {
        this.container.current.addEventListener('touchstart', disableScroll, {
          passive: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.container.current) {
        this.container.current.removeEventListener('touchstart', disableScroll);
      }

      this.removeDocumentListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var wasControlled = prevProps.value != null;
      var isControlled = this.props.value != null; // Warn about uncontrolled > controlled

      if (!wasControlled && isControlled) {
        this._warnUncontrolledToControlled = true;
        console.warn('Looks like the type of the value prop changed from being uncontrolled to controlled; this can lead to bugs.', 'See more: https://fb.me/react-controlled-components');
      } // Warn about controlled > uncontrolled


      if (wasControlled && !isControlled) {
        this._warnControlledToUncontrolled = false;
        console.warn('Looks like the type of the value prop changed from being controlled to uncontrolled; this can lead to bugs.', 'See more: https://fb.me/react-controlled-components');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          max = _this$props5.max,
          min = _this$props5.min,
          disabled = _this$props5.disabled,
          style = _this$props5.style,
          className = _this$props5.className;
      var active = this.state.active;
      var value = this.selectValue();
      var ratio = value / max;
      return /*#__PURE__*/React.createElement(Wrapper, {
        role: "slider",
        disabled: disabled,
        "aria-disabled": disabled,
        "aria-valuenow": value,
        "aria-valuemin": min,
        "aria-valuemax": max,
        ref: this.container,
        tabIndex: 0,
        style: style,
        className: className,
        draggable: false,
        onPointerDownCapture: this.handlePointerDown
      }, /*#__PURE__*/React.createElement(TrackLower, {
        className: "slider--lower-track",
        draggable: false,
        style: {
          transform: "scale3d(".concat(ratio, ", 1, 1)")
        }
      }), /*#__PURE__*/React.createElement(ThumbWrapper, {
        style: {
          width: ratio * 100 + '%'
        }
      }, /*#__PURE__*/React.createElement(Thumb, {
        className: "slider--thumb",
        draggable: false,
        disabled: disabled,
        active: active
      })), /*#__PURE__*/React.createElement(TrackUpper, {
        className: "slider--upper-track",
        draggable: false,
        style: {
          transform: "scale3d(".concat(1 - ratio, ", 1, 1)")
        }
      }));
    }
  }]);

  return Slider;
}(React.PureComponent);

_defineProperty(Slider, "defaultProps", {
  min: 0,
  max: 1,
  initialValue: 0
});

var _default = Slider;
exports["default"] = _default;